/* tslint:disable */
/* eslint-disable */
/**
 * zbo-connector API
 * zbo-connector - client
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
*
* @export
* @enum {string}
*/
export var EnumZboTypDokumentu;
(function (EnumZboTypDokumentu) {
    EnumZboTypDokumentu["ZADOST"] = "ZADOST";
    EnumZboTypDokumentu["PRILOHA"] = "PRILOHA";
    EnumZboTypDokumentu["ROZHODNUTI_ZUK"] = "ROZHODNUTI_ZUK";
    EnumZboTypDokumentu["ROZHODNUTI_ZUK_ZMENA"] = "ROZHODNUTI_ZUK_ZMENA";
    EnumZboTypDokumentu["OOP"] = "OOP";
    EnumZboTypDokumentu["OOP_ZMENA"] = "OOP_ZMENA";
    EnumZboTypDokumentu["STANOVISKO_OPP"] = "STANOVISKO_OPP";
    EnumZboTypDokumentu["STANOVISKO_JINE"] = "STANOVISKO_JINE";
    EnumZboTypDokumentu["SMLOUVA"] = "SMLOUVA";
    EnumZboTypDokumentu["SMLOUVA_DODATEK"] = "SMLOUVA_DODATEK";
    EnumZboTypDokumentu["MIPO"] = "MIPO";
    EnumZboTypDokumentu["PODKLADY"] = "PODKLADY";
})(EnumZboTypDokumentu || (EnumZboTypDokumentu = {}));
//# sourceMappingURL=enum-zbo-typ-dokumentu.js.map